import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const CREATE_PATIENT_NOTE = 'CREATE_PATIENT_NOTE';
export const CREATE_PATIENT_NOTE_SUCCESS = 'CREATE_PATIENT_NOTE_SUCCESS';
export const CREATE_PATIENT_NOTE_FAIL = 'CREATE_PATIENT_NOTE_FAIL';
export const UPDATE_PATIENT_NOTE = 'UPDATE_PATIENT_NOTE';
export const UPDATE_PATIENT_NOTE_SUCCESS = 'UPDATE_PATIENT_NOTE_SUCCESS';
export const UPDATE_PATIENT_NOTE_FAIL = 'UPDATE_PATIENT_NOTE_FAIL';
export const ADD_PATIENT_NOTE_RESOURCE = 'ADD_PATIENT_NOTE_RESOURCE';
export const ADD_PATIENT_NOTE_RESOURCE_SUCCESS = 'ADD_PATIENT_NOTE_RESOURCE_SUCCESS';
export const ADD_PATIENT_NOTE_RESOURCE_FAIL = 'ADD_PATIENT_NOTE_RESOURCE_FAIL';
export const REMOVE_PATIENT_NOTE_RESOURCE = 'REMOVE_PATIENT_NOTE_RESOURCE';
export const REMOVE_PATIENT_NOTE_RESOURCE_SUCCESS = 'REMOVE_PATIENT_NOTE_RESOURCE_SUCCESS';
export const REMOVE_PATIENT_NOTE_RESOURCE_FAIL = 'REMOVE_PATIENT_NOTE_RESOURCE_FAIL';
export const DELETE_PATIENT_NOTE = 'DELETE_PATIENT_NOTE';
export const DELETE_PATIENT_NOTE_SUCCESS = 'DELETE_PATIENT_NOTE_SUCCESS';
export const DELETE_PATIENT_NOTE_FAIL = 'DELETE_PATIENT_NOTE_FAIL';

// Reducer
export default function patientsNotesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type, payload } = action;
  switch (type) {
    case CREATE_PATIENT_NOTE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }

        return {
          ...dataItem,
          'Patient Notes': [
            payload['Patient Notes'],
            ...dataItem['Patient Notes'],
          ],
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_PATIENT_NOTE_SUCCESS:
    case ADD_PATIENT_NOTE_RESOURCE_SUCCESS:
    case REMOVE_PATIENT_NOTE_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Patient Notes']) {
          return dataItem;
        }

        const newNotes = dataItem['Patient Notes'].map((notesItem) => {
          if (notesItem.ID !== payload.ID) {
            return notesItem;
          }

          return {
            ...notesItem,
            ...payload,
          };
        });

        return {
          ...dataItem,
          'Patient Notes': newNotes,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_PATIENT_NOTE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Patient Notes']) {
          return dataItem;
        }
        const index = dataItem['Patient Notes'].findIndex(item => item.ID === payload.ID);
        if (index === -1) {
          return dataItem;
        }
        const newPatientNotes = [
          ...dataItem['Patient Notes'].slice(0, index),
          ...dataItem['Patient Notes'].slice(index + 1),
        ];
        return {
          ...dataItem,
          'Patient Notes': newPatientNotes,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function createPatientNote(payload) {
  return { type: CREATE_PATIENT_NOTE, payload };
}

export function createPatientNoteSuccess(payload) {
  return { type: CREATE_PATIENT_NOTE_SUCCESS, payload };
}

export function createPatientNoteFail(payload) {
  return { type: CREATE_PATIENT_NOTE_FAIL, payload };
}

export function updatePatientNote(payload) {
  return { type: UPDATE_PATIENT_NOTE, payload };
}

export function updatePatientNoteSuccess(payload) {
  return { type: UPDATE_PATIENT_NOTE_SUCCESS, payload };
}

export function updatePatientNoteFail(payload) {
  return { type: UPDATE_PATIENT_NOTE_FAIL, payload };
}

export function addPatientNoteResource(payload) {
  return { type: ADD_PATIENT_NOTE_RESOURCE, payload };
}

export function addPatientNoteResourceSuccess(payload) {
  return { type: ADD_PATIENT_NOTE_RESOURCE_SUCCESS, payload };
}

export function addPatientNoteResourceFail(payload) {
  return { type: ADD_PATIENT_NOTE_RESOURCE_FAIL, payload };
}

export function removePatientNoteResource(payload) {
  return { type: REMOVE_PATIENT_NOTE_RESOURCE, payload };
}

export function removePatientNoteResourceSuccess(payload) {
  return { type: REMOVE_PATIENT_NOTE_RESOURCE_SUCCESS, payload };
}

export function removePatientNoteResourceFail(payload) {
  return { type: REMOVE_PATIENT_NOTE_RESOURCE_FAIL, payload };
}

export function deletePatientNote(payload) {
  return { type: DELETE_PATIENT_NOTE, payload };
}

export function deletePatientNoteSuccess(payload) {
  return { type: DELETE_PATIENT_NOTE_SUCCESS, payload };
}

export function deletePatientNoteFail(payload) {
  return { type: DELETE_PATIENT_NOTE_FAIL, payload };
}

// Requests
export function requestCreatePatientNote(payload) {
  return callApi('patient/notes/', 'POST', payload);
}

export function requestUpdatePatientNote(payload) {
  return callApi('patient/notes/', 'PATCH', payload);
}

export function requestDeletePatientNote(payload) {
  return callApi(`patient/notes/?id=${payload.ID}`, 'DELETE');
}

export function requestAddPatientNoteResource(payload) {
  return callApi('patient/notes/change_resource/add/', 'POST', payload);
}

export function requestRemovePatientNoteResource(payload) {
  return callApi('patient/notes/change_resource/remove/', 'POST', payload);
}

// Sagas
function* createPatientNoteSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreatePatientNote, values);
    yield put(createPatientNoteSuccess({
      'Record Number': values['User Record Number'],
      'Patient Notes': res.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createPatientNoteFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updatePatientNoteSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdatePatientNote, values);
    yield put(updatePatientNoteSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updatePatientNoteFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* addPatientNoteResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestAddPatientNoteResource, values);
    yield put(addPatientNoteResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(addPatientNoteResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* removePatientNoteResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestRemovePatientNoteResource, values);
    yield put(removePatientNoteResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(removePatientNoteResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deletePatientNoteSaga(action) {
  try {
    const res = yield call(requestDeletePatientNote, action.payload);
    yield put(deletePatientNoteSuccess(action.payload));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(deletePatientNoteFail(err.data));
  }
}

export function* patientsNotesSaga() {
  yield takeEvery(CREATE_PATIENT_NOTE, createPatientNoteSaga);
  yield takeEvery(UPDATE_PATIENT_NOTE, updatePatientNoteSaga);
  yield takeEvery(DELETE_PATIENT_NOTE, deletePatientNoteSaga);
  yield takeEvery(ADD_PATIENT_NOTE_RESOURCE, addPatientNoteResourceSaga);
  yield takeEvery(REMOVE_PATIENT_NOTE_RESOURCE, removePatientNoteResourceSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/patientsNotes.js